import { Modal } from '@/components/modal/modal';
import styles from './styles.module.css';
import { GetProviderResponseItem } from '@/api/api.schemas';
import { ModalButtons } from '@/components/modal/modal-buttons';
import { useTranslation } from '@/contexts/i18n-context';

interface NewPatientModalProps {
  isOpen: boolean;
  onClose: () => void;
  provider: GetProviderResponseItem;
  onSelect: (providerId: string, hasSeenProvider: boolean) => void;
}

const translationBase = 'visit.providerSelection';

export function NewPatientModal({ isOpen, onClose, provider, onSelect }: NewPatientModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.modal}>
      <h2 className="h4">
        {t(`${translationBase}.existingPatientModal.title`, { fullName: provider.fullName })}
      </h2>

      <ModalButtons
        confirm={{
          text: t('common.yes'),
          onClick: () => {
            onClose();
            onSelect(provider.id, true);
          },
        }}
        cancel={{
          text: t('common.no'),
          onClick: () => {
            onClose();
            onSelect(provider.id, false);
          },
        }}
      />
    </Modal>
  );
}
